module.exports = __webpack_public_path__ + "img/hr-brown-asterisk-19.e556d04f.png";